export enum FlatTypes {
  'Commercial' = 'Commercial',
  'Residential' = 'Residential',
  'Suite Room' = 'Suite Room',
  '1BHK' = '1BHK',
  '1.5BHK' = '1.5BHK',
  '2BHK' = '2BHK',
  '2.5BHK' = '2.5BHK',
  '3BHK' = '3BHK',
  '3.5BHK' = '3.5BHK',
  '4BHK' = '4BHK',
  '4.5BHK' = '4.5BHK',
  '5BHK' = '5BHK',
  '5.5BHK' = '5.5BHK',
  '4BHK + Home Theatre' = '4BHK + Home Theatre',
  '4BHK+Home Theatre-Duplex' = '4BHK+Home Theatre-Duplex',
  '3BHK+1(Home Theatre or Bedroom)' = '3BHK+1(Home Theatre or Bedroom)',
  '4BHK+1(Home Theatre or Bedroom)' = '4BHK+1(Home Theatre or Bedroom)'
}
